import { useState, useEffect } from 'react'
import api, { IDashboardEmployeeImport, IPaginationInfo, IPaginationParams } from '@api'
export interface UseDashboardEmployeeImportListHook {
  imports: IDashboardEmployeeImport[]
  loading: boolean
  reload: (paginationParams?: IPaginationParams | undefined) => void
  pageInfo: IPaginationInfo | null
  setPerPage: (perPage: number) => void
  setPage: (pageNumber: number) => void
}

const defaultAmountOfPages = 5

export default function useDashboardEmployeeImportList(): UseDashboardEmployeeImportListHook {
  const [imports, setImports] = useState<IDashboardEmployeeImport[]>([])
  const [loading, setLoading] = useState(true)
  const [pageInfo, setPageInfo] = useState<IPaginationInfo | null>(null)
  const [perPage, setPerPage] = useState<number>(defaultAmountOfPages)
  const [pageNumber, setPageNumber] = useState<number>(1)

  const load = (paginationParams?: IPaginationParams) => {
    api.employee.import
      .dashboardList({
        perPage: paginationParams?.perPage ? paginationParams.perPage : defaultAmountOfPages,
        page: paginationParams?.pageNumber ? paginationParams.pageNumber : 1,
      })
      .then(({ imports, pageInfo }) => {
        setImports(imports)
        setPageInfo(pageInfo)
        setLoading(false)
      })
  }

  useEffect(() => {
    load({ pageNumber, perPage })
  }, [pageNumber, perPage])

  return {
    imports,
    loading,
    reload: load,
    pageInfo,
    setPerPage: (val) => {
      setPerPage(val)
      setPageNumber(1)
    },
    setPage: setPageNumber,
  }
}
